/* eslint-disable react/jsx-max-props-per-line */
import React from 'react';
import moment from 'moment';
import { Box, Chip, Typography } from '@mui/material';
import { renderStatus } from 'components/v2/cell-renderers/status';
import {
  CATEGORIA_STAT_COLORS,
  formatBRL,
  getCategoriaChartColor,
  getTipoNotaLabel,
  getTipoPagamentoLabel,
} from './constants';

export const formatTransactionDate = (value) => {
  if (value == null) return '—';
  const m = moment(value);
  return m.isValid() ? m.format('DD/MM/YYYY') : '—';
};

export const renderCategoriaCell = (categoria, tipoNota) => {
  const label = getTipoNotaLabel(tipoNota, categoria);
  const colorKey = CATEGORIA_STAT_COLORS[label] || 'default';
  const chartColor = getCategoriaChartColor(categoria, tipoNota);

  return (
    <Chip
      label={label}
      size="small"
      color={colorKey === 'default' ? 'default' : colorKey}
      variant="outlined"
      sx={{
        borderColor: chartColor,
        color: chartColor,
        fontWeight: 600,
      }}
    />
  );
};

export const renderValorCell = (valor) => (
  <Typography variant="body2" sx={{ fontWeight: 600, width: '100%', textAlign: 'right' }}>
    {formatBRL(valor)}
  </Typography>
);

export const renderDescricaoCell = (descricao) => (
  <Box sx={{ whiteSpace: 'normal', wordBreak: 'break-word', lineHeight: 1.4 }}>
    {descricao || '—'}
  </Box>
);

export const renderInspecaoCell = (inspecao) => (
  <Chip
    label={inspecao === true || inspecao === 'true' ? 'Sim' : 'Não'}
    size="small"
    variant="outlined"
    color={inspecao === true || inspecao === 'true' ? 'primary' : 'default'}
  />
);

export const renderValidateCell = (validate) => {
  const status = validate ?? 'AGUARDANDO_VALIDACAO';
  let label = 'Aguardando Validação';
  if (status === 'VALIDADO') label = 'Validado';
  if (status === 'INVALIDADO') label = 'Invalidado';
  return renderStatus({ value: status, label });
};

export const renderPagamentoCell = (tipoPagamento) => (
  <Typography variant="body2">{getTipoPagamentoLabel(tipoPagamento)}</Typography>
);
